/**
 * Created by dmitry on 07.08.2026
 */

const debugTooltip = function (location) {
    const scene = cleverapps.Scenes.GetRunningScene();

    [scene.debugTooltip, scene.debugTooltipTarget].forEach((node) => node && node.removeFromParent());
    scene.debugTooltip = scene.debugTooltipTarget = undefined;

    if (!location) {
        return;
    }

    const target = scene.debugTooltipTarget = new cc.Node();
    target.setAnchorPoint(0.5, 0.5);
    target.setContentSize2(120, 120);
    target.setPosition(scene.width / 2, scene.height / 2);
    scene.movingNode.addChild(target);

    const border = new cc.DrawNode();
    border.drawRect(cc.p(0, 0), cc.p(target.width, target.height), cc.color(255, 0, 0, 40), 2, cc.color(255, 0, 0, 200));
    target.addChild(border);

    scene.debugTooltip = new cleverapps.UI.Tooltip(target, {
        location: cleverapps.UI.Tooltip[location],
        size: cleverapps.styles.UI.Tooltip.SIZE.medium,
        text: "Tooltip preview: the quick brown fox jumps over the lazy dog",
        duration: 3600
    });
    scene.movingNode.addChild(scene.debugTooltip);
};

cleverapps.override(cleverapps.Tool, {
    tooltip: {
        above: () => debugTooltip("LOCATION_ABOVE"),
        below: () => debugTooltip("LOCATION_BELOW"),
        hide: () => debugTooltip()
    }
});
